import styled from 'styled-components';

import { colors } from 'styles/theme/colors';
import { FONT_WEIGHT_MEDIUM } from 'styles/theme/textStyles';
import { BodySmall } from 'styles/typography';
import TrashIcon from 'svg/TrashIcon';

interface Props {
  filename: string;
  onOpen?: () => void;
  onRemove?: () => void;
  error?: boolean;
  progress?: number;
  testId?: string;
}

export default function BenefitFileRow({ filename, onOpen, onRemove, error, progress, testId }: Props) {
  const uploading = progress !== undefined && progress < 100;

  return (
    <Row data-testid={testId ?? 'benefit-file'} $error={error}>
      {onOpen ? (
        <Name as='button' type='button' onClick={onOpen}>
          {filename}
        </Name>
      ) : (
        <Name>{filename}</Name>
      )}
      {error && <Status>Upload failed</Status>}
      {uploading && <Status>Uploading… {Math.round(progress)}%</Status>}
      {onRemove && (
        <Remove type='button' onClick={onRemove} aria-label={`Remove ${filename}`} data-testid='benefit-file-remove'>
          <TrashIcon width={14} height={14} />
        </Remove>
      )}
    </Row>
  );
}

const Row = styled.div<{ $error?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  border: 1px solid ${({ $error }) => ($error ? colors.red100 : colors.black10)};
  border-radius: 4px;
  background: ${colors.black3};
`;

const Name = styled(BodySmall)`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  background: none;
  border: none;
  padding: 0;
  font-family: inherit;
  font-weight: ${FONT_WEIGHT_MEDIUM};
  color: ${colors.blue100};
  cursor: pointer;
`;

const Status = styled(BodySmall)`
  color: ${colors.black50};
`;

const Remove = styled.button`
  display: inline-flex;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${colors.black75};
`;
